import React from "react";
import {
  Form,
  Switch,
  Typography,
  Divider,
  Space,
  Button,
  Row,
  Col,
} from "antd";

const { Text, Title } = Typography;

const AccessPermissions: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Access permissions submitted:", values);
    // Handle form submission
  };

  return (
    <div>
      <Title level={3} style={{ marginTop: "0" }}>
        Access and Permissions
      </Title>
      <Text type="secondary">Manage access and permissions</Text>
      <Divider style={{ margin: "8px 0" }} />

      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Form form={form} onFinish={onFinish} layout="vertical">
          {/* Roles & Assigned Permissions */}
          <div style={{ marginBottom: 12 }}>
            <Text strong>Roles & Assigned Permissions</Text>
            <div style={{ marginTop: 8 }}>
              <Form.Item name="rolesEnabled" valuePropName="checked">
                <Switch checkedChildren="On" unCheckedChildren="Off" />
              </Form.Item>
            </div>
          </div>

          {/* Department Level Access */}
          <div style={{ marginBottom: 12 }}>
            <Text strong>Department Level Access</Text>
            <div style={{ marginTop: 8 }}>
              <Form.Item name="deptAccessEnabled" valuePropName="checked">
                <Switch checkedChildren="On" unCheckedChildren="Off" />
              </Form.Item>
            </div>
          </div>

          {/* Module Access Summary */}
          <div style={{ marginBottom: 12 }}>
            <Text strong>Module Access Summary</Text>
            <div style={{ marginTop: 8 }}>
              <Form.Item name="moduleSummaryEnabled" valuePropName="checked">
                <Switch checkedChildren="On" unCheckedChildren="Off" />
              </Form.Item>
            </div>
          </div>

          <Divider style={{ margin: "12px 0" }} />

          <Form.Item style={{ marginTop: 8 }}>
            <Button type="primary" htmlType="submit" style={{ width: 120 }}>
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </Space>
    </div>
  );
};

export default AccessPermissions;
